import { ValidationType } from "./ValidationType";
import { cloneDeep } from 'lodash';
import transfreeDetails from "./Models/TransfreeDetails";

//  after testing, those are valid area code as for now
const VALID_AREA_CODE = [
  '02',   // Geographic: Central East region (NSW, ACT)
  '03',   // Geographic: South-east region (VIC, TAS)
  '04',   // Digital Mobile services (GSM, 3G and 4G)
  '07',   // Geographic: North-east region (QLD)
  '08',   // Geographic: Central and West region (SA, NT, WA)
]
const VALID_MOBILE_CODE = [
  '04'   // Digital Mobile services (GSM, 3G and 4G)
]


function boolify(value) {
  const lowercaseValue = value.toLowerCase();
  if (lowercaseValue === 'true' || lowercaseValue === 'false') {
    return lowercaseValue === 'true' ? true : false;
  }
  return value;
}

function validEmail(email) {
  let reg = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/)
  return reg.test(email);
}

function validPhoneNum(phoneNum, isInternational) {
  let reg = null;
  if (isInternational) { // if it's international, return phone # starts with +
    reg = new RegExp(/^\+\d+$/);
  } else {  // else check for valid phone number
    phoneNum = phoneNum.replace('(', '').replace(')', '')
    const areaCodes = VALID_AREA_CODE.join('|');
    reg = new RegExp('^(' + areaCodes + ')\\d{8}$');
  }
  return reg.test(phoneNum);
}

function validMobileNum(mobileNum, isInternational) {
  let reg = null;
  if (isInternational) { // if it's international, return phone # starts with +
    reg = new RegExp(/^\+\d+$/);
  } else {  // else check for valid phone number
    const areaCodes = VALID_MOBILE_CODE.join('|');
    reg = new RegExp('^(' + areaCodes + ')\\d{8}$');
  }
  return reg.test(mobileNum);
}

function isEmpty(str) {
  if (typeof (str) === 'string') {
    return 0 === str.trim().length; // is not valid
  } else {
    return false;
  }
}

function validInput(input) {
  return !isEmpty(input) && input !== "Please Choose..." && input !== "Please Select...";
}

function validDropDown(input) {
  return input !== "Please Choose..." && input !== "Please Select..." && input !== "";
}

// check if the phone # starts with +, and followed by all numbers
/**
 * Recieve string, need to check the type of the number, can be object and then cause error msg
 * @param {string} number
 */
function validInternationalNumber(number) {
  const phoneNums = number.substring(1, number.length);
  return allNumeric(phoneNums) && number[0] === "+";
}

function allNumeric(number) {
  const reg = new RegExp("^[0-9]+$");
  return reg.test(number);
}

function validState(state) {
  // check if the object is valid
  for (var key of Object.keys(state)) {
    if (key.includes('valid') && key !== 'isValidated') {
      if (state[key] === false)
        return false;
    }
  }
  return true;
}

function validInteger(number) {
  return !isNaN(number) && (number * 1) >= 0;
}

function validDate(date) {
  const reg = new RegExp(/^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/);
  return reg.test(date);
}

function validYear(year) {
  const reg = new RegExp(/\d\d\d\d/);
  const emptyString = !year || year.length === 0;
  return emptyString || reg.test(year);
}

function validInputFields(inputs) {
  const updatedInputs = cloneDeep(inputs);
  let validInputs = true;
  for (let index = 0; index < updatedInputs.length; index++) {
    const updatedInput = updatedInputs[index];
    updatedInput.modified = true;
    if (updatedInput.validation) {
      const { validationType, value } = updatedInput;
      if (validationType) {
        for (let index = 0; index < validationType.length; index++) {
          const validation = validationType[index];
          switch (validation.type) {
            case ValidationType.IsRequired:
              validInputs = validInputs && validInput(value);
              break;
            case ValidationType.AllDigit:
              if (value && value.length > 0) {
                validInputs = validInputs && allNumeric(value);
              }
              break;
            case ValidationType.ValidNumber:
              if (value && parseFloat(value) > 0) {
                validInputs = validInputs && validInteger(value);
              }
              break;
            case ValidationType.ValidId:
              validInputs = validInputs && validId(value);
              break;
            case ValidationType.ValidTravelMode:
              validInputs = validInputs && validModeOfTravel(value);
              break;
            case ValidationType.ValidDate:
              if (value && value.length > 0) {
                validInputs = validInputs && validDate(value);
              }
              break;
            case ValidationType.ValidPhoneNumber:
              if (value && value.length > 0) {
                validInputs = validInputs && validPhoneNum(value);
              }
              break;
            case ValidationType.ValidMobilePhone:
              if (value && value.length > 0) {
                validInputs = validInputs && validMobileNum(value);
              }
              break;
            case ValidationType.ValidEmail:
              if (value && value.length > 0) {
                validInputs = validInputs && validEmail(value);
              }
              break;
            case ValidationType.ValidYear:
              if (value && value.length > 0) {
                validInputs = validInputs && validYear(value);
              }
              break;
            case ValidationType.ValidTime:
              if (value && value.length > 0) {
                validInputs = validInputs && validTime(value);
              }
              break;
            default:
              break;
          }
        }
      }
    }
    updatedInputs[index] = updatedInput;
  }
  return {
    validInputs: validInputs,
    updatedInputs: updatedInputs
  };
}

function validModeOfTravel(id) {
  return parseInt(id) !== 6;
}

function validId(id) {
  return parseInt(id) !== 0 && !isNaN(id);
}

function validTime(value, duration) {
  const unmaskedTime = transfreeDetails.unmaskPhoneNumber(value);
  if (!unmaskedTime) return true;
  if (unmaskedTime && unmaskedTime.length < 4) return false;
  const splitedTime = value.split(':');
  const hour = splitedTime[0];
  const minute = splitedTime[1];
  if (hour < 1 || hour > 12) return false;
  if (minute < 0 || minute > 59) return false;
  return true;
}

export default {
  validEmail, validInput, allNumeric, validDropDown, validInternationalNumber, validState, validInputFields, validInteger,
  boolify, validDate, validPhoneNum, validMobileNum, validYear, validModeOfTravel, validId, validTime
};
